import { Injectable, signal } from '@angular/core';

export type LoginPromptReason = 'cart' | 'generic';

/**
 * Zentraler Auslöser für den globalen "Bitte zuerst anmelden"-Dialog.
 * Wird von Services/Komponenten genutzt, die eine Aktion nur für
 * angemeldete Nutzer erlauben, ohne selbst einen Redirect zu erzwingen.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginPromptService {
  private _visible = signal(false);
  private _reason = signal<LoginPromptReason>('generic');
  private _returnUrl = signal<string | null>(null);

  readonly visible = this._visible.asReadonly();
  readonly reason = this._reason.asReadonly();
  readonly returnUrl = this._returnUrl.asReadonly();

  show(reason: LoginPromptReason = 'generic', returnUrl?: string | null): void {
    this._reason.set(reason);
    this._returnUrl.set(returnUrl ?? null);
    this._visible.set(true);
  }

  hide(): void {
    this._visible.set(false);
  }
}
